import { call, put } from 'redux-saga/effects';
import { requestGetGroup, requestGetGroups, requestGetGroupBillingEntities, requestUpdateGroup, requestCreateGroup, requestCompleteGroup, requestDeleteGroup, requestRestoreGroup, requestAddProjectToGroup, requestRemoveProjectFromGroup } from '../requests/group';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetGroup(action) {
    try {
        const { groupId, callback } = action.payload;
        const response = yield call(requestGetGroup, groupId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: "error", message: safeErrorMessage(error) }));
    }
}

export function* handleGetGroups(action) {
    try {
        const { start, limit, state = 'open', callback } = action.payload;
        const response = yield call(requestGetGroups, start, limit, state);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetGroupBillingEntities(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetGroupBillingEntities);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}

export function* handleUpdateGroup(action) {
    try {
        const { groupId, groupData, callback } = action.payload;
        const response = yield call(requestUpdateGroup, groupId, groupData);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleCreateGroup(action) {
    try {
        const { groupData, callback } = action.payload;
        const response = yield call(requestCreateGroup, groupData);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleCompleteGroup(action) {
    try {
        const { groupId, options, callback } = action.payload;
        const response = yield call(requestCompleteGroup, groupId, options);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        if (callback) {
            callback(null);
        }
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteGroup(action) {
    try {
        const { groupId, callback } = action.payload;
        const response = yield call(requestDeleteGroup, groupId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (action.payload?.callback) {
            action.payload.callback(null);
        }
    }
}

export function* handleRestoreGroup(action) {
    try {
        const { groupId, callback } = action.payload;
        const response = yield call(requestRestoreGroup, groupId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleAddProjectToGroup(action) {
    try {
        const { groupId, projectId, callback } = action.payload;
        const response = yield call(requestAddProjectToGroup, groupId, projectId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleRemoveProjectFromGroup(action) {
    try {
        const { groupId, projectId, callback } = action.payload;
        const response = yield call(requestRemoveProjectFromGroup, groupId, projectId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}